import type { Link, SpanContext, SpanStatus, TimeInput } from '@opentelemetry/api';
import { ATTRS_ERROR_MESSAGE } from './SemanticAttributes';
import type { SpanAttribute, SpanAttributes, Span } from './Span';
import { SpanStatusCode } from './Span';

export class CustomSpan {
  constructor(private readonly originalSpan: Span) {}

  spanContext(): SpanContext {
    return this.originalSpan.spanContext();
  }

  isRecording(): boolean {
    return this.originalSpan.isRecording();
  }

  setAttribute(key: string, value: SpanAttribute): this {
    this.originalSpan.setAttribute(key, value);
    return this;
  }

  setAttributes(attributes: SpanAttributes): this {
    this.originalSpan.setAttributes(attributes);
    return this;
  }

  addEvent(name: string, attributesOrStartTime?: SpanAttributes | TimeInput, startTime?: TimeInput): this {
    this.originalSpan.addEvent(name, attributesOrStartTime, startTime);
    return this;
  }

  addLink(link: Link): this {
    this.originalSpan.addLink(link);
    return this;
  }

  addLinks(links: Array<Link>): this {
    this.originalSpan.addLinks(links);
    return this;
  }

  setStatus(status: SpanStatus): this {
    this.originalSpan.setStatus(status);
    return this;
  }

  updateName(name: string): this {
    this.originalSpan.updateName(name);
    return this;
  }

  succeed(endTime?: TimeInput) {
    this.originalSpan.setStatus({ code: SpanStatusCode.OK });
    this.originalSpan.end(endTime);
  }

  fail(error: Error | string, time?: TimeInput) {
    if (typeof error === 'string') {
      this.originalSpan.setStatus({ code: SpanStatusCode.ERROR, message: error });
      this.originalSpan.setAttribute(ATTRS_ERROR_MESSAGE, error);
      this.originalSpan.end();
      return;
    }

    this.originalSpan.recordException(error, time);
    this.originalSpan.setStatus({ code: SpanStatusCode.ERROR, message: error.message });
    this.originalSpan.setAttribute(ATTRS_ERROR_MESSAGE, error.message);
    this.originalSpan.end();
  }

  discard(endTime?: TimeInput): void {
    this.originalSpan.end(endTime);
  }
}
